import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { faAlignRight } from "@fortawesome/free-solid-svg-icons";
import { text } from "@fortawesome/fontawesome-svg-core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submittedDateFrom: new Date(),
      submittedDateTo: new Date(),
      sAwbNo: "",
      export: false,
    };
  }

  componentDidMount = () => {};

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Doc Number",
          fixed: "left",
          accessor: "doc_no",
          width: 200,
          filterable: true,
          Cell: (row) => (
            <div style={{ textAlign: "left" }}>
              <span>{row.value}</span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Status",
          accessor: "status",
          // fixed: "left",
          width: 80,
          filterable: true,
          Cell: (row) => (
            <div
              style={
                ({ textAlign: "left" },
                {
                  color:
                    row.value == "WAITING"
                      ? "RED"
                      : row.value == "SENT"
                      ? "GREEN"
                      : "BLACK",
                })
              }
            >
              <span>{row.value}</span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Doc Date",
          accessor: "doc_date",
          filterable: true,
          width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>
                <span>
                  {row.value !== null &&
                  row.value !== "" &&
                  row.value !== "null"
                    ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Sender",
          accessor: "org_src_name",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          //   width: 80,
        },
        {
          Header: "Destination",
          accessor: "destination_name",
          filterable: true,
          width: 150,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          // ,filterable: true
        },

        // {
        //   Header: "Destination Name",
        //   accessor: "destination_name",
        //   filterable: true,
        //   width: 200,
        //   Filter: ({ filter, onChange }) => (
        //     <input
        //       placeholder="search.."
        //       onChange={(event) => onChange(event.target.value)}
        //       //   defaultValue="Search.."
        //       value={filter ? filter.value : ""}
        //       //   value="2111"
        //       style={{
        //         width: "100%",
        //         // backgroundColor: "gray",
        //         //   color: "gray",
        //       }}
        //     />
        //   ),
        // },
        {
          Header: "Total Doc",
          accessor: "total_doc",
          filterable: true,
          width: 80,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>{row.value}</span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Awb No",
          accessor: "awb_no",
          filterable: true,
          width: 200,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Awb Date",
          accessor: "awb_date",
          filterable: true,
          width: 150,

          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>
                <span>
                  {row.value !== null &&
                  row.value !== "" &&
                  row.value !== "null"
                    ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        //========
        {
          Header: "Submitted by",
          accessor: "submitted_by",
          filterable: true,
          width: 200,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Submit Date",
          accessor: "creation_date",
          filterable: true,
          width: 150,

          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>
                <span>
                  {row.value !== null &&
                  row.value !== "" &&
                  row.value !== "null"
                    ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        //========================
        {
          Header: "Sent by",
          accessor: "sent_by",
          filterable: true,
          width: 200,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Sent Date",
          accessor: "sent_date",
          filterable: true,
          width: 150,

          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>
                <span>
                  {row.value !== null &&
                  row.value !== "" &&
                  row.value !== "null"
                    ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        //=================
        {
          Header: "Received by",
          accessor: "received_by",
          filterable: true,
          width: 200,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
        },
        {
          Header: "Received Date",
          accessor: "received_date",
          filterable: true,
          width: 150,

          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>
                <span>
                  {row.value !== null &&
                  row.value !== "" &&
                  row.value !== "null"
                    ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            </div>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        {
          Header: "Surat Pengantar",
          accessor: "filepath",
          width: 150,
          Cell: (row) => {
            return (
              <div style={{ textAlign: "center", color: "blue" }}>
                <span>
                  {/* <button
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    this.deleteLine(row.value);
                  }}
                >
                  Remove
                </button> */}
                  {/* <a onClick={() => this.deleteLine(row.value)}>Remove</a> */}
                  <button
                    className="btn btn-secondary btn-sm"
                    type="button"
                    // onClick={() => {
                    //   this.goDetail(row.value);
                    // }}
                    onClick={() => {
                      window.open(row.value, "_blank");
                    }}
                  >
                    Download <i className="fas fa-download" />
                  </button>
                </span>
              </div>
            );
          },
        },
        {
          Header: "Action",
          accessor: "doc_id",

          Cell: (row) => {
            return (
              <div style={{ textAlign: "center", color: "blue" }}>
                <span>
                  {/* <button
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    this.deleteLine(row.value);
                  }}
                >
                  Remove
                </button> */}
                  {/* <a onClick={() => this.deleteLine(row.value)}>Remove</a> */}
                  <button
                    className="btn btn-info btn-sm"
                    type="button"
                    onClick={() => {
                      this.goDetail(row.value);
                    }}
                  >
                    View <i className="fas fa-eye" />
                  </button>
                </span>
              </div>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  goDetail = (id) => {
    // let { row } = rows;
    this.props.history.push("/admin/documentmonitor/summary/" + id);
  };

  handleSearch = () => {
    let url = "/api/collect/v1/monitoring/get-group-document";
    let param = {
      org_id: this.state.user.org_id,
      origin: this.state.user.origin,
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
      export: this.state.export,
    };

    this.setState({ loading: true });
    requester.postCollect(url, param, {
      success: function (response) {
        let { data } = response.data;

            if (this.state.export) {
              let url = data.filepath.fullurl;
              window.open(url, "_blank");
            }

        this.setState({
          loading: false,
          dataTable: data.header,
          baseTable: data.header,
          // export: this.state.export,
        });

      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
    // this.getBranch();
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleChangeAwb = (e) => {
    this.setState({ sAwbNo: e.target.value });
  };

  handleExport = () => {
    this.setState({ export: true });
    let app = this;
    window.setTimeout(() => {
      app.handleSearch();
    }, 200);
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="clearfix">&nbsp;</div>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label
                                    htmlFor="inputEmail3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Date From
                                  </label>
                                  <div className="col-sm-8">
                                    <DatePicker
                                      selected={this.state.submittedDateFrom}
                                      dateFormat="d-MMM-yyyy"
                                      className="form-control"
                                      popperPlacement="top-end"
                                      // value={this.state.sDocDate}
                                      onChange={this.handleSubmittedDateFrom}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label
                                    htmlFor="inputEmail3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Date To
                                  </label>
                                  <div className="col-sm-8">
                                    <DatePicker
                                      selected={this.state.submittedDateTo}
                                      dateFormat="d-MMM-yyyy"
                                      className="form-control"
                                      popperPlacement="top-end"
                                      // value={this.state.sDocDate}
                                      onChange={this.handleSubmittedDateTo}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div className="clearfix">&nbsp;</div> */}
                            {/* <div className="row">
                              <div className="col-md-2 mt-1">Awb No. </div>
                              <div className="col-lg-3">
                                <input
                                  type="text"
                                  autoComplete="off"
                                  className="form-control"
                                  id="scanfield"
                                  name="ref_number"
                                  placeholder=""
                                  onChange={this.handleChangeAwb.bind(this)}
                                  // onKeyDown={this.handleKeyDown.bind(this)}
                                  // value={this.state.ref_number}
                                />
                              </div>
                            </div> */}
                            <div className="clearfix">&nbsp;</div>
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              <div className="col-md-3">
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.handleExport.bind(this)}
                                >
                                  <i class="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
